import React, { Component } from "react";
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { MDBDataTableV5, MDBCol, MDBTableBody, MDBTableHead } from "mdbreact";
import { Link } from "react-router-dom";

import Notiflix from "notiflix";
import PostApiCall from "../../Api";
import GetApiCall from "../../GETAPI";
import moment from "moment";
import Parser from "html-react-parser";

import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import Modal from "react-responsive-modal";

import "react-responsive-modal/styles.css";

var otp = Math.floor(100000 + Math.random() * 900000);

class cutomerList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      Details: [],
      isdeleted: false,
      searchInput: "",
      Name: "",
      Accountno: "",
      open: false,
      ID: "",
      Email: "",
      Mobile: "",
      ChitId: "",
    };
  }

  componentDidMount() {
    Notiflix.Loading.Init({
      svgColor: "rgb(216, 23, 100)",
    });

    Notiflix.Loading.Dots("");

    GetApiCall.getRequest("Get_ApproveData").then((resultdes) =>
      resultdes.json().then((obj) => {
        console.log(obj.data);

        if (obj.data) {
          this.setState(
            {
              Details: obj.data,
            },
            () => console.log(this.state.Details)
          );
        }
        if (obj.data[0] != "") {
          var newArr = [...obj?.data];
          newArr.map((data, i) => {
            this.setState({
              Name: data.fld_name,
              Accountno: data.fld_accountno,
              Mobile: data.fld_mobile,
            });
          });
        }

        Notiflix.Loading.Remove();
      })
    );
  }

  seachBarHandler = (e) => {
    this.setState({ ...this.state, searchInput: e.target.value });
  };

  ApproveData() {
    if (this.state.Name != "") {
      if (this.state.Accountno != "") {
        this.onPostCustomer();
      } else {
        Notiflix.Notify.Failure("Please enter scheme account number");
      }
    } else {
      Notiflix.Notify.Failure("Please enter name");
    }
  }

  onPostCustomer = () => {
    var det = localStorage.getItem("LoginDetail");
    var detail = JSON.parse(det);

    // console.log(this.state.Email)

    Notiflix.Loading.Dots("Please wait...");

    PostApiCall.postRequest(
      {
        id: this.state.ID,
        name: this.state.Name,
        email: this.state.Email,
        mobile: this.state.Mobile,
        usertype: "Customer",
        password: this.state.Mobile,
        updatedon: moment().format("lll"),
        updatedby: detail[0].fld_userid,
      },
      "Update_Customer_Password"
    ).then((result) =>
      result.json().then((obj) => {
        if (result.status == 200 || result.status == 201) {
          // console.log(obj)
          // Notiflix.Loading.Remove();
          // Notiflix.Notify.Success('User Successfully added.')
          // window.location.reload()
          this.onPostApprove(obj);
        } else {
          Notiflix.Loading.Remove();
          Notiflix.Notify.Failure(obj.data);
          // console.log(obj.data)
        }
      })
    );
  };

  onPostApprove(obj) {
    Notiflix.Loading.Dots("Please wait...");

    PostApiCall.postRequest(
      {
        name: this.state.Name,
        clientStatus: "Approved",
        id: this.state.ID,
        userid: JSON.parse(JSON.stringify(obj.data[0])).UserId,
      },
      "Update_RegisterClientRequest"
    ).then((resultFootwareS) =>
      resultFootwareS.json().then((objBookC) => {
        if (resultFootwareS.status == 200 || resultFootwareS.status == 201) {
          this.onPostSchema();
          // Notiflix.Loading.Remove();
          // Notiflix.Notify.Success('Accessories size successfully added.')
          // window.location.reload()
        } else {
          Notiflix.Loading.Remove();
          Notiflix.Notify.Failure(objBookC.data);
        }
      })
    );
  }

  onPostSchema = () => {
    // console.log('chitapprove')
    Notiflix.Loading.Dots("Please wait...");

    PostApiCall.postRequest(
      {
        accountno: this.state.Accountno,
        clientStatus: "Approved",
        client: this.state.ChitId,
      },
      "Update_RequestChitSchema"
    ).then((result) =>
      result.json().then((obj5) => {
        if (result.status == 200 || result.status == 201) {
          this.onPostMailer();
          // Notiflix.Loading.Remove();
          // Notiflix.Notify.Success('Accessories size successfully added.')
          // window.location.reload()
        } else {
          Notiflix.Loading.Remove();
          Notiflix.Loading.Failure(obj5.data);
        }
      })
    );
  };

  onPostMailer = () => {
    fetch(
      "https://api.co3.live/api/smsapi?key=0228b2bd609b68fa69a1c13680445924" +
        "&sms=Dear " +
        this.state.Name +
        ", Your request for Online Payment of Jewel Savings Scheme is approved. Please check Email for details." +
        "Regards " +
        `Shanthi Jewellers&route=2&sender=SANTII&number=${this.state.Mobile}&templateid=1707161917447486270`
      // `https://api.co3.live/api/smsapi?key=0228b2bd609b68fa69a1c13680445924&route=2&sender=SANTII&number=7982828789&templateid=1707161917447486270&sms=Dear
      //   Mr.Deepak Your request for Online Payment of Jewel Savings Scheme is approved. Please check Email for details RegardsShanthi Jewellers`
    ).then((res) => res.json());

    //   console.log('Approve')
    Notiflix.Loading.Dots("Please wait...");
    PostApiCall.postRequest(
      {
        name: this.state.Name,
        email: this.state.Email,
        mobile: this.state.Mobile,
        password: this.state.Mobile,
      },
      "Customer_mailer"
    ).then((result) =>
      result.json().then((obj) => {
        if (result.status == 200 || result.status == 201) {
          // console.log(obj)
          Notiflix.Loading.Remove();
          Notiflix.Notify.Success("Client Succefully Approved.");
          window.location.reload();
          // this.onPostMailer()
        } else {
          Notiflix.Loading.Remove();
          Notiflix.Loading.Failure(obj.data);
        }
      })
    );
  };

  // Reject(){

  // }

  // onPostSchema3=()=>{
  //     Notiflix.Loading.Dots('Please wait...');

  //     PostApiCall.postRequest ({
  //         accountno : this.state.Accountno,
  //         clientStatus : 'Rejected',
  //         client : this.state.ChitId,

  //     },"Update_RequestChitSchema").then((result) =>
  //     result.json().then(obj => {
  //         if(result.status == 200 || result.status == 201){

  //             Notiflix.Loading.Remove();
  //             Notiflix.Notify.Success('User is  successfully rejected.')
  //             window.location.reload()
  //         }else
  //         {
  //             Notiflix.Loading.Remove();
  //                 Notiflix.Notify.Failure(obj.data);
  //         }
  //     })
  //     )
  // }

  render() {
    const data = {
      columns: [
        {
          label: "S.No.",
          field: "serial",
          sort: "disabled",
          width: 150,
        },
        {
          label: "Name",
          field: "name",
          sort: "disabled",
          width: 270,
        },
        {
          label: "Scheme Book Number",
          field: "accountNumber",
          sort: "disabled",
          width: 270,
        },

        {
          label: "Email",
          field: "email",
          sort: "disabled",
          width: 270,
        },

        {
          label: "Scheme Name",
          field: "transaction",
          sort: "disabled",
          width: 200,
        },
        {
          label: "Duration",
          field: "paidAmount",
          sort: "disabled",
          width: 100,
        },

        {
          label: "Status",
          field: "status",
          sort: "disabled",
          width: 150,
        },
        {
          label: "Action",
          field: "action",
          sort: "disabled",
          width: 100,
        },
      ],
      rows: this.state.Details.filter((data) => {
        // console.log(data.name)

        let name =
          data.fld_name !== null
            ? [
                ...data.fld_name
                  .toLowerCase()
                  .matchAll(this.state.searchInput.toLowerCase()),
              ]
            : "";
        let accn =
          data.fld_accountno !== null
            ? [
                ...data.fld_accountno
                  .toLowerCase()
                  .matchAll(this.state.searchInput.toLowerCase()),
              ]
            : "";

        let chit_Schema =
          data.fld_chitschema !== null
            ? [
                ...data.fld_chitschema
                  .toLowerCase()
                  .matchAll(this.state.searchInput.toLocaleLowerCase()),
              ]
            : "";

        let status =
          data.fld_clientStatus !== null
            ? [
                ...data.fld_clientStatus
                  .toLowerCase()
                  .matchAll(this.state.searchInput.toLocaleLowerCase()),
              ]
            : "";
        // console.log(name)

        let email =
          data.fld_email !== null
            ? [
                ...data.fld_email
                  .toLowerCase()
                  .matchAll(this.state.searchInput.toLowerCase()),
              ]
            : "";

        if (this.state.searchInput.length > 0 && name[0]) {
          return data;
        }

        if (this.state.searchInput.length > 0 && accn[0]) {
          return data;
        }
        if (this.state.searchInput.length > 0 && chit_Schema[0]) {
          return data;
        }

        if (this.state.searchInput.length > 0 && status[0]) {
          return data;
        }

        if (this.state.searchInput.length > 0 && email[0]) {
          return data;
        }

        if (this.state.searchInput.length == 0) {
          return data;
        }
      }).map((data, i) => {
        //  console.log(data)
        return {
          serial: <td>{i + 1}</td>,
          name: <td>{data.fld_name}</td>,

          accountNumber: <td>{data.fld_accountno}</td>,

          email: <td>{data.fld_email}</td>,
          transaction: <td>{data.fld_chitschema}</td>,
          paidAmount: <td>{data.fld_chitamount}</td>,
          status: <td>{data.chitstatus}</td>,
          action: (
            <td className="text-center actionuser">
              <button
                className={"btn"}
                type="submit"
                style={{
                  backgroundColor: "#880105",
                  color: "#e1b761",
                  float: "right",
                  marginLeft: "10px",
                }}
                onClick={() => {
                  Notiflix.Loading.Dots("Please wait...");

                  PostApiCall.postRequest(
                    {
                      name: data.fld_name,
                      clientStatus: "Rejected",
                      id: data.fld_id,
                      userid: 0,
                    },
                    "Update_RegisterClientRequest"
                  ).then((resultFootwareS) =>
                    resultFootwareS.json().then((objBookC) => {
                      if (
                        resultFootwareS.status == 200 ||
                        resultFootwareS.status == 201
                      ) {
                        //    ========ChitScheme Status Reject=====

                        PostApiCall.postRequest(
                          {
                            accountno: data.fld_accountno,
                            clientStatus: "Rejected",
                            client: data.clientid,
                          },
                          "Update_RequestChitSchema"
                        ).then((result) =>
                          result.json().then((obj) => {
                            if (result.status == 200 || result.status == 201) {
                              Notiflix.Loading.Remove();
                              Notiflix.Notify.Success(
                                "User is  successfully rejected."
                              );
                              window.location.reload();
                            } else {
                              Notiflix.Loading.Remove();
                              Notiflix.Notify.Failure(obj.data);
                            }
                          })
                        );
                      } else {
                        Notiflix.Loading.Remove();
                        Notiflix.Notify.Failure(objBookC.data);
                      }
                    })
                  );
                }}
              >
                Reject
              </button>

              <button
                className={"btn"}
                style={{
                  backgroundColor: "#880105",
                  color: "#e1b761",
                  float: "right",
                }}
                onClick={() => {
                  this.setState({
                    Name: data.fld_name,
                    Accountno: data.fld_accountno,
                    ID: data.fld_id,
                    open: true,
                    Email: data.fld_email,
                    Mobile: data.fld_mobile,
                    ChitId: data.clientid,
                  });
                  Notiflix.Loading.Dots("Please wait...");

                  PostApiCall.postRequest(
                    {
                      id: data.fld_client,
                    },
                    "Get_AccountList"
                  ).then((results5) =>
                    results5.json().then((obj5) => {
                      if (results5.status == 200 || results5.status == 201) {
                        //  console.log(obj5.data)

                        if (obj5.data.length != "undefined") {
                          this.setState({
                            AccountData: obj5.data,
                          });
                        }

                        Notiflix.Loading.Remove();
                      }
                    })
                  );
                }}
              >
                Approve
              </button>
            </td>
          ),
        };
      }),
    };

    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            <Modal class="modal-content" open={this.state.open} center>
              <div class="modal-content modelcontent3">
                <div class="modal-header">
                  <h4 class="modal-title">Approve Client Request</h4>
                </div>
                <div class="modal-body">
                  <div className="row">
                    <div class="col-md-6">
                      <div class="form-group mb-3">
                        <label for="validationCustom01">
                          Name <span className="mandatory">*</span>
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          value={this.state.Name}
                          onChange={(text) => {
                            this.setState({
                              Name: text.target.value,
                            });
                          }}
                        />
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="form-group mb-3">
                        <label for="validationCustom01">
                          Scheme Book Number{" "}
                          <span className="mandatory">*</span>
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          value={this.state.Accountno}
                          onChange={(text) => {
                            this.setState({
                              Accountno: text.target.value,
                            });
                          }}
                        />
                      </div>
                    </div>

                    <div
                      class="col-md-12"
                      style={{
                        display:
                          this.state.AccountData &&
                          this.state.AccountData.length > 1
                            ? ""
                            : "none",
                      }}
                    >
                      <div class="form-group mb-3">
                        <label for="validationCustom01">
                          Scheme Book Number List
                        </label>
                        <table className="table table-bordered">
                          <tr>
                            <th>Scheme Book No</th>
                            <th>Action</th>
                          </tr>
                          {this.state.AccountData &&
                            this.state.AccountData.map((data, i) => {
                              return (
                                <tr>
                                  <td>{data.fld_accountno}</td>
                                  <td>
                                    {" "}
                                    <button
                                      className={"btn"}
                                      type="submit"
                                      style={{
                                        backgroundColor: "#880105",
                                        color: "#e1b761",
                                        float: "right",
                                        marginLeft: "10px",
                                      }}
                                      onClick={() => {
                                        PostApiCall.postRequest(
                                          {
                                            accountno: data.fld_accountno,
                                            clientStatus: "Closed",
                                            client: data.clientid,
                                          },
                                          "Update_RequestChitSchema"
                                        ).then((result) =>
                                          result.json().then((obj) => {
                                            if (
                                              result.status == 200 ||
                                              result.status == 201
                                            ) {
                                              Notiflix.Loading.Remove();
                                              Notiflix.Notify.Success(
                                                "Account is  successfully closed."
                                              );
                                              window.location.reload();
                                            } else {
                                              Notiflix.Loading.Remove();
                                              Notiflix.Loading.Failure(
                                                obj.data
                                              );
                                            }
                                          })
                                        );
                                      }}
                                    >
                                      Close
                                    </button>
                                  </td>
                                  <td></td>
                                </tr>
                              );
                            })}
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="modal-footer">
                  <button
                    className={"btn"}
                    type="submit"
                    style={{
                      float: "right",
                      backgroundColor: "#880105",
                      color: "#e1b761",
                    }}
                    onClick={() => {
                      this.setState({
                        open: false,
                      });
                    }}
                  >
                    Close
                  </button>

                  <button
                    className={"btn"}
                    type="submit"
                    style={{
                      float: "right",
                      backgroundColor: "#880105",
                      color: "#e1b761",
                    }}
                    onClick={this.ApproveData.bind(this)}
                  >
                    Approve
                  </button>
                  <span></span>
                </div>
              </div>
            </Modal>

            {/* Render Breadcrumb */}
            <Breadcrumbs
              title={"Manage Clients"}
              breadcrumbItem={"View Clients"}
            />
            <Row>
              <Col xl="12">
                <Card className="overflow-hidden">
                  <div
                    className="maxXchange-bg-soft-pink"
                    style={{ background: "rgb(171, 61, 0)" }}
                  >
                    <Row>
                      <Col xs="6">
                        <div className="maxXchange-text p-3">
                          <h5 className="maxXchange-text">Approve Client </h5>
                        </div>
                      </Col>
                    </Row>
                    <Row></Row>
                  </div>

                  <Card className="overflow-hidden">
                    <div
                      className="maxXchange-bg-soft-pink"
                      style={{ background: "#dfb65c" }}
                    >
                      <Row>
                        <Col xs="6">
                          <div className="maxXchange-text p-3">
                            <h5 className="maxXchange-text">
                              Approve Client List
                            </h5>
                          </div>
                        </Col>
                      </Row>
                    </div>
                    <CardBody className="pt-0">
                      <Row>
                        <MDBCol
                          md="3"
                          style={{ marginBottom: "10px", marginTop: "10px" }}
                        >
                          <input
                            className="form-control"
                            type="text"
                            placeholder="Search"
                            aria-label="Search"
                            onChange={(e) => this.seachBarHandler(e)}
                            value={this.state.searchInput}
                          />
                        </MDBCol>
                        <Col md="12">
                          <MDBDataTableV5
                            striped
                            bordered
                            small
                            data={data}
                            searchBottom={false}
                            seachTop={true}
                          >
                            <MDBTableHead columns={data.columns} />
                            <MDBTableBody rows={data.rows} />
                          </MDBDataTableV5>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>

                  {/* <WelcomeComp /> */}
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}
export default cutomerList;
